module.exports = __webpack_public_path__ + "img/amcard.8dbd997a.png";